export default __webpack_public_path__ + "static/media/two.3066845d.png";